import React from 'react';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider, useAuth } from './auth';
import Header from './Components/Header';
import ResumeFlowBar from './ShiftFlow/ResumeFlowBar';
import AppRoutes from './Routes/Routes';
import ErrorBoundary from './Components/ErrorBoundary';
import './App.css';
// Shared by several lazy pages; imported once here in a fixed order so the
// production build never has to pick an order between chunks.
import './ShiftFlow/ShiftFlow.css';
import './Tasks/NotNeededButton.css';
import './Codes/Codes.css';
import './Components/MediaEmbeds.css';
import {GOOGLE_CLIENT_ID} from "./constants";
import { useKioskIdle } from './kioskIdle';
import { isKioskUser } from './kioskSession';


function AuthProviderWithNavigate({ children }) {
    const navigate = useNavigate();

    const handleLoginSuccess = () => {
        navigate('/');
    };

    return (
        <AuthProvider onLoginSuccess={handleLoginSuccess}>
            {children}
        </AuthProvider>
    );
}

function AppContent() {
    const { user, logout } = useAuth();
    useKioskIdle(isKioskUser(user));

    return (
        <ErrorBoundary>
            <div className="app-container">
                <Header user={user} logout={logout} />
                {user && <ResumeFlowBar />}
                <main className="main-content">
                    <AppRoutes />
                </main>
            </div>
        </ErrorBoundary>
    );
}

function App() {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <Router>
                <AuthProviderWithNavigate>
                    <AppContent />
                </AuthProviderWithNavigate>
            </Router>
        </GoogleOAuthProvider>
    );
}

export default App;